import type { Action } from '@ngrx/store';
import { createReducer, on } from '@ngrx/store';
import type { OptOutState } from '../state/opt-out.state';
import { initialOptOutState } from '../state/opt-out.state';
import { FetchOptOutList, FetchOptOutListFailure, FetchOptOutListSuccess } from '../action/opt-out.action';

const optOutReducer = createReducer(
  initialOptOutState,
  on(FetchOptOutList, (state) => ({
      ...state,
      loading: true,
      loaded: false,
      error: null,
    })),

  on(FetchOptOutListSuccess, (state, { list, totalRecords, pageNumber }) => ({
      ...state,
      data: {
        currentPage: pageNumber || 1,
        optOuts: list,
        totalRecords,
      },
      loading: false,
      loaded: true,
      error: null,
    })),
  on(FetchOptOutListFailure, (state: OptOutState, { error }) => ({
      ...state,
      loading: false,
      loaded: true,
      error,
    })),
);

export function OptOutReducer(state: OptOutState | undefined, action: Action) {
  return optOutReducer(state, action);
}
